// Déclaration des variables globales (état partagé de l'application)
//TODO: declarer avec window.thermo.xyz pour eviter les conflitss
export let currentDataset;
//window.thermo = window.thermo || {};
//window.thermo.dataset = null;
export let dataset;
export let g_listOrigin = "neep";//NEEP ou EnergyStar(ES)
export const activeList = {
  name: null,
  file: null
};

export const lang = document.documentElement.lang || "fr";
export let typeList = null;

// Setters : les liaisons importées (import { x }) sont en lecture seule en ES modules,
// ces fonctions permettent donc aux autres modules de modifier l'état partagé ci-dessus.
export function setCurrentDataset(value) {
  currentDataset = value;
}
export function setListOrigin(value) {
  g_listOrigin = value;
}

// Corrélation des champs entre les différentes listes de données (affichable dans le tableau)
export const correlationFields = [
  ["ahri","ahri_reference_number"],
  ["pd_id","pd_id"],
  ["marque","outdoor_unit_brand_name"],
  ["modele_exterieur","model_number"],
  ["modele_interieur","indoor_unit_model_number"],
  ["fournaise","furnace_model_number"],
  ["haut_rendement","cold_climate"],
  ["puissance_nominale","cooling_capacity_btu_h"],
  ["puissance_moins_8","heating_capacity_at_17_f_btu_h"],
  ["aide_financiere_a_proprio-maison","TTG_AF_EffAlone"],
  ["aide_financiere_b_proprio-maison",""],
  ["aide_financiere_a_entrepreneur-maison","TTG_AF_Maison1"],
  ["aide_financiere_b_entrepreneur-maison",""],
  ["aide_financiere_a_entrepreneur-plex","TTG_AF_Multi1"],
  ["aide_financiere_b_entrepreneur-plex","TTG_AF_Multi4"],
  ["aide_financiere_a_office-habitation","TTG_Ext2"],
  ["aide_financiere_b_office-habitation",""],
  ["admissible_bonification","program_fecc_admissible"],
  ["col_bonification","TTG_colBonification"],
  ["TTG_Ext5","TTG_Ext5"]
]
